export default function wasFilterEdited(currentFilter, nextFilter) {
  return (
    JSON.stringify(currentFilter.fieldFormat()) !== JSON.stringify(nextFilter.fieldFormat()) ||
    JSON.stringify(currentFilter.filterFields()) !== JSON.stringify(nextFilter.filterFields()) ||
    currentFilter.type() !== nextFilter.type()
  );
}
